export const HOUSING_TYPE_FIELD_LABEL = "Housing type";
export const PUBLIC_ASSISTANCE_QUESTION_TEXT =
  "Do you receive a housing voucher or subsidy (Section 8 Voucher, FHEPS, CITYFHEPS, HASA, etc.)?";
export const PUBLIC_ASSISTANCE_SECTION_DESCRIPTION =
  "For example, Section 8 Voucher, FHEPS, CITYFHEPS, HASA, etc.";
export const PUBLIC_ASSISTANCE_SECTION_LABEL = "Housing voucher?";
